import { DesignDataDocument } from 'src/generated/operations.ts';
import { ApolloClient } from '@apollo/client/core';

type Props = {
    content: string;
    apollo: ApolloClient<unknown>;
}

export const fetchDesignData = async ({ content, apollo }: Props): Promise<{ result: string; error?: unknown }> => {
    if (content.length === 0) {
        return { result: '' };
    }
    try {
        const data = await apollo.query({
            query: DesignDataDocument,
            variables: { content },
        });
        return {
            result: data.data.designData ?? '',
        };
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return { result: '', error: e };
    }
};
